module.exports = __webpack_public_path__ + "static/media/eng_d_2340.672f25ce.mp4";